import axios from 'axios';
import jwt_decode from 'jwt-decode';


let refreshingToken = false;
let tokenPromise = null;
let currentToken = null;
let interceptorAdded = false;

const axiosInstance = axios.create({
    baseURL: 'api/',
    withCredentials: true,
});

export const useAxios = () => {


    async function getNewToken(token, req) {


        const rs = await axios.post('api/security/refreshtoken', {
            refresh_token: token.refresh_token,
        });



        const new_tokens = rs.data;


        return new_tokens;
    }

    async function refreshToken(token, req) {


        if (refreshingToken) {
            await tokenPromise;
            return currentToken;
        }

        refreshingToken = true;

        // Crea una nuova promessa per il processo di refresh
        tokenPromise = (async () => {

            // Verifica se il token è scaduto
            const decodedToken = await jwt_decode(sessionStorage.getItem("access_token"));
            let expirationDate = new Date(decodedToken.exp * 1000);
            const currentDate = new Date();

            if (expirationDate < currentDate) {

                const newToken = await getNewToken(token, req);
                currentToken = newToken;

            }
            else {

                currentToken = token;
            }

            refreshingToken = false;

        })();

        // Attendi il completamento del processo di refresh
        await tokenPromise;

        // Resetta la promessa
        tokenPromise = null;

        return currentToken;

    }

    if (!interceptorAdded) {
        axiosInstance.interceptors.request.use(
            async (req) => {


                let token = {
                    id_token: sessionStorage.getItem("id_token"),
                    access_token: sessionStorage.getItem("access_token"),
                    refresh_token: sessionStorage.getItem("refresh_token")
                };


                // Aggiorna il token prima della chiamata asincrona
                token = await refreshToken(token, req);


                sessionStorage.setItem("id_token", token.id_token);
                sessionStorage.setItem("access_token", token.access_token);
                sessionStorage.setItem("refresh_token", token.refresh_token);


                req.headers['Authorization'] = 'Bearer ' + token.id_token;
                req.headers['AuthorizationRole'] = token.access_token;

                return req;
            }
        );
        interceptorAdded = true;
    }

    return axiosInstance;
}